<div class="video-testimonial-reference">
  <div class="video-testimonial-reference__grid">
    <img
      *ngIf="item?.image?.value && loadMedia"
      src="{{ item.image.value.src }}"
      alt="{{ item.image.value.alt }}"
      loading="lazy"
      [ngStyle]="{aspectRatio: item.image?.value?.width / item.image?.value?.height}"
    />
    <div>
      <h4 *ngIf="item?.author?.value">{{ item.author.value }}</h4>
      <p *ngIf="item?.occupation?.value">{{ item.occupation.value }}</p>
    </div>
  </div>
  <div
    *ngIf="item?.quote?.value"
    class="video-testimonial-reference__quote"
    [innerHTML]="item.quote.value | safe"
  ></div>
  <div *ngIf="item?.link?.value" class="video-testimonial-reference__link">
    <app-bg-button
      [data]="item.link.value"
      [buttonColor]="item.linkColor.value"
    ></app-bg-button>
  </div>
</div>
